import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";

import { BaseApiService } from "../../../services/base";
import { DTOModel } from "../../../models/base/dto-model";
import { STOModel } from "../../../models/base/sto-model";

import { toastifyResponse } from "../../../utils/toastify-response/toastify-response";

import { RecoverButton, IconRecoverButton } from "./styles";
export interface PropToChange {
  propName: string;
  propValue: any;
}

interface Props {
  items: DTOModel[];
  itemName?: string;
  serviceApiInstance: BaseApiService<DTOModel, STOModel>;
  handleReload?: () => Promise<void>;
  updateGlobalStateCallback?: () => Promise<void>;
  notifyParent?: (ids: string[]) => void;
  disabled?: boolean;
  buttonText?: boolean;
  useIcon?: boolean;
}

const RecoverItem = ({
  items,
  itemName,
  serviceApiInstance,
  handleReload,
  updateGlobalStateCallback,
  disabled = false,
  notifyParent,
  buttonText = false,
  useIcon = false,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.recover_item";

  const [disable, setDisable] = useState<boolean>(false);

  const recoverItem = async () => {
    const confirmed = !!items
      ? window.confirm(
          (itemName ? itemName + "\r\n" : "") + t(`components.window_confirm_modal.multiple_recover_question`)
        )
      : window.confirm((itemName ? itemName + "\r\n" : "") + t(`components.window_confirm_modal.recover_question`));
    if (confirmed && !!items) {
      let toSave: STOModel[];

      toSave = items.map((item) => ({ ...item, isDeleted: false, recover: true }));

      const response = await serviceApiInstance.saveItems(toSave);

      if (!response.error) {
        handleReload && (await handleReload());
        updateGlobalStateCallback && updateGlobalStateCallback();
        notifyParent && notifyParent(items.map((item) => item.id));
      }

      toastifyResponse(response);
    }
  };

  const constantInItems = useCallback((): boolean => {
    return items.filter((_item) => _item.isConstant).length > 0;
  }, [items]);

  return (
    <>
      {useIcon ? (
        <IconRecoverButton>
          <FontAwesomeIcon icon={faRotateLeft} />
        </IconRecoverButton>
      ) : (
        <RecoverButton
          disabled={disabled || constantInItems() || disable}
          onClick={recoverItem}
          buttonText={buttonText}
        >
          {`Recover`}
        </RecoverButton>
      )}

      {/* </MessageContainer> */}
    </>
  );
};

export default RecoverItem;
